/*
 * WAKA Referral Tracking — assets/waka-referral.js
 * Ported 2026-06-06 from the Venue component components/referral-tracking/waka-referral-tracking.liquid.
 *
 * Captures referral partner codes from the URL (?ref=PARTNER), persists them in
 * sessionStorage across navigation, and attaches them as a cart attribute so the
 * Shopify order webhook can attribute the sale to the referring partner.
 *
 * CONTRACT — do NOT rename: the sessionStorage key `waka_ref` and the cart attribute
 * `referral_partner` are read by the Firebase shopifyOrderWebhook (WAKA referral system).
 * Flow: go.waka.surf/PARTNER -> Firebase redirect -> waka.surf/...?ref=PARTNER ->
 *       this script -> cart attribute -> order -> webhook matches partner -> commission.
 * Runs silently on every page; no UI.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'waka_ref';

  // 1. Capture ?ref= from the URL (normalise to uppercase to match Firestore partner doc IDs).
  try {
    var ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) {
      sessionStorage.setItem(STORAGE_KEY, ref.toUpperCase().trim());
    }
  } catch (e) {
    // sessionStorage can be unavailable in private browsing — ignore.
  }

  // 2. Attach the saved partner code to the cart as a note attribute.
  try {
    var savedRef = sessionStorage.getItem(STORAGE_KEY);
    if (savedRef) {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { referral_partner: savedRef } })
      }).catch(function (err) {
        // Non-critical — don't block the page if this fails.
        console.warn('WAKA Referral: cart attribute update failed', err);
      });
    }
  } catch (e) {
    // Fail silently — referral tracking is non-critical.
  }
})();
